module.exports = __webpack_public_path__ + "img/profile-bg.ed6e42cc.jpg";